const transformActionResponse = ({ results = [], count }) => ({
  results,
  count,
});

export default transformActionResponse;
